/**
 * When using multiple questionnaires within a primary survey, a linkID does
 * not guarantee the uniqueness of a question.  It's important to persist the survey ID
 * with the link ID to gauruntee uniqueness
 */
export default class PrimarySurveyItemIdentifier {
  private _surveyId: string;
  private _linkId: string;

  constructor(surveyId: string, linkId: string) {
    this._surveyId = surveyId;
    this._linkId = linkId;
  }

  public get surveyId() {
    return this._surveyId;
  }

  public get linkId() {
    return this._linkId;
  }

  public get key() {
    return `${this.surveyId}-${this.linkId}`;
  }

  public equals(otherIdentifier: PrimarySurveyItemIdentifier) {
    return (
      this.surveyId === otherIdentifier?.surveyId &&
      this.linkId === otherIdentifier?.linkId
    );
  }
}
